import type { GetServerSidePropsContext, GetStaticPropsContext, NextPageContext } from "next";
import type { AppContext } from "next/app";

import Cookie from "./Cookie";
import { isbot } from "isbot";
import { extractClientIdFromGACookie } from "./gtag";

type CookieContext = NextPageContext | GetServerSidePropsContext | undefined;
let ctx: CookieContext;
let staticCtx: GetStaticPropsContext | null = null;
let userAgent: string | null = null;

let cookie: Cookie | undefined;

// Cache for GA client_id extracted from cookies
let cachedClientId: string | null = null;

export const getCookie = () => {
  return cookie ?? new Cookie(); 
};
export const getCookieFromContext = (ctxOrCookie?: GetServerSidePropsContext) => {
  return new Cookie(ctxOrCookie);
};

export const setAppContext = (ctxOrCookie: AppContext) => {
  ctx = ctxOrCookie.ctx;
  staticCtx = null;
  cookie = new Cookie(ctx);

  // Extract GA client_id from cookie
  cachedClientId = null; // Reset
  if (ctx?.req?.headers?.cookie) {
    try {
      const gaCookie = cookie?.get('_ga');
      if (gaCookie) {
        cachedClientId = extractClientIdFromGACookie(gaCookie);
      }
    } catch (error) {
      console.warn('Failed to extract GA client_id:', error);
      cachedClientId = null;
    }
  }

  if (ctx?.req?.headers['user-agent']) {
    userAgent = ctx.req.headers['user-agent'] as string;
  }
};

export const setContext = (ctxOrCookie: CookieContext) => {
  ctx = ctxOrCookie;
  staticCtx = null;
  cookie = new Cookie(ctx);

  // Extract GA client_id from cookie
  cachedClientId = null; // Reset
  if (ctx?.req?.headers?.cookie) {
    try {
      const gaCookie = cookie?.get('_ga');
      if (gaCookie) {
        cachedClientId = extractClientIdFromGACookie(gaCookie);
      }
    } catch (error) {
      console.warn('Failed to extract GA client_id:', error);
      cachedClientId = null;
    }
  }

  if (ctx?.req?.headers['user-agent']) {
    userAgent = ctx.req.headers['user-agent'] as string;
  }
};

export const setStaticContext = (ctxOrCookie: GetStaticPropsContext) => {
  staticCtx = ctxOrCookie;
  cookie = new Cookie();
};

export const getLocale = () => ctx?.locale || staticCtx?.locale || "";
export const isBot = () => userAgent ? isbot(userAgent) : false;

export const getCachedClientId = () => cachedClientId;
export const getUserAgent = () => userAgent;